var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _path7, _path8, _path9, _rect, _g3, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCurrencyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 84,
    viewBox: "0 0 81 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.634 1.27798C38.9953 0.491998 40.6726 0.491999 42.034 1.27798L74.007 19.7376C75.3684 20.5236 76.207 21.9762 76.207 23.5482V60.4675C76.207 62.0394 75.3684 63.492 74.007 64.278L42.034 82.7376C40.6726 83.5236 38.9953 83.5236 37.634 82.7376L5.66092 64.278C4.29955 63.492 3.46092 62.0394 3.46092 60.4675V23.5482C3.46092 21.9762 4.29955 20.5236 5.66092 19.7376L37.634 1.27798Z",
    fill: "#0064C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8838 1.71094C39.0905 1.01427 40.5775 1.01427 41.7842 1.71094L73.7568 20.1709C74.9634 20.8675 75.7069 22.1546 75.707 23.5479V60.4678C75.7069 61.861 74.9634 63.1481 73.7568 63.8447L41.7842 82.3047C40.5775 83.0014 39.0905 83.0014 37.8838 82.3047L5.91113 63.8447C4.70455 63.1481 3.96104 61.861 3.96094 60.4678V23.5479C3.96104 22.1546 4.70456 20.8675 5.91113 20.1709L37.8838 1.71094Z",
    stroke: "url(#paint0_linear_3379_90918)",
    strokeOpacity: 0.09
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.72,
    filter: "url(#filter0_i_3379_90918)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.634 1.27798C38.9953 0.491998 40.6726 0.491999 42.034 1.27798L74.007 19.7376C75.3684 20.5236 76.207 21.9762 76.207 23.5482V60.4675C76.207 62.0394 75.3684 63.492 74.007 64.278L42.034 82.7376C40.6726 83.5236 38.9953 83.5236 37.634 82.7376L5.66092 64.278C4.29955 63.492 3.46092 62.0394 3.46092 60.4675V23.5482C3.46092 21.9762 4.29955 20.5236 5.66092 19.7376L37.634 1.27798Z",
    fill: "white",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3379_90918",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 72,
    height: 81
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7883 0.77017C38.1496 -0.0158144 39.8269 -0.0158136 41.1883 0.770171L72.2953 18.7298C73.6567 19.5158 74.4953 20.9684 74.4953 22.5403V58.4597C74.4953 60.0316 73.6567 61.4842 72.2953 62.2702L41.1883 80.2298C39.8269 81.0158 38.1496 81.0158 36.7883 80.2298L5.68124 62.2702C4.31987 61.4842 3.48124 60.0316 3.48124 58.4597V22.5403C3.48124 20.9684 4.31987 19.5158 5.68124 18.7298L36.7883 0.77017Z",
    fill: "url(#paint1_linear_3379_90918)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0381 1.20312C38.2447 0.506458 39.7318 0.506457 40.9385 1.20312L72.0449 19.1631C73.2515 19.8597 73.995 21.1468 73.9951 22.54V58.46C73.995 59.8532 73.2515 61.1403 72.0449 61.8369L40.9385 79.7969C39.7318 80.4935 38.2448 80.4935 37.0381 79.7969L5.93164 61.8369C4.72506 61.1403 3.98155 59.8532 3.98145 58.46V22.54C3.98155 21.1468 4.72506 19.8597 5.93164 19.1631L37.0381 1.20312Z",
    stroke: "url(#paint2_linear_3379_90918)",
    strokeOpacity: 0.24
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3379_90918)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3379_90918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8379 15.7975C63.3532 25.1287 65.446 38.8856 64.678 44.5977C70.438 37.6856 70.054 27.7975 69.142 23.7175C67.8867 18.1015 56.3259 11.3046 48.8379 15.7975Z",
    fill: "white",
    fillOpacity: 0.32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3379_90918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8379 64.5111C14.3226 55.1799 12.2298 41.423 12.9978 35.7109C7.23774 42.623 7.62174 52.5111 8.53375 56.5911C9.7891 62.2071 21.3498 69.004 28.8379 64.5111Z",
    fill: "white",
    fillOpacity: 0.24
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-52.3438 -54.0547H138.602L82.1532 13.4098L55.225 80.8743H23.9768L0.360615 13.4098L-52.3438 -54.0547Z",
    fill: "url(#paint3_linear_3379_90918)",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0687 77.855L17.0605 -29.4258H57.3808L46.5807 77.855H36.0687Z",
    fill: "url(#paint4_linear_3379_90918)",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1598 -29.4258L51.7676 74.6869H60.8396L119.592 -29.4258H83.1598Z",
    fill: "url(#paint5_linear_3379_90918)",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.94886 -29.4258L29.4434 74.6869H20.3713L-38.3811 -29.4258H-1.94886Z",
    fill: "url(#paint6_linear_3379_90918)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3379_90918",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -15,
    y: -30,
    width: 111,
    height: 111
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -14.1797,
    y: -29.4258,
    width: 109.441,
    height: 109.441,
    fill: "url(#paint7_radial_3379_90918)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3379_90918)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3379_90918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6319 41.3016C62.9221 40.655 62.2987 40.0299 61.6538 40.3209C61.5141 40.3856 61.4066 40.4933 61.3421 40.6334C61.0412 41.28 61.6753 41.9051 62.3202 41.6141C62.4599 41.5494 62.5674 41.4417 62.6319 41.3016Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4229 8.48907C53.7131 7.84247 53.0897 7.21742 52.4448 7.50839C52.3051 7.57305 52.1976 7.68082 52.1331 7.82092C51.8322 8.46752 52.4663 9.09257 53.1112 8.8016C53.2509 8.73694 53.3584 8.62917 53.4229 8.48907Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9209 57.3758C14.2111 56.7292 13.5877 56.1041 12.9429 56.3951C12.8031 56.4598 12.6957 56.5675 12.6312 56.7076C12.3302 57.3542 12.9644 57.9793 13.6092 57.6883C13.749 57.6237 13.8565 57.5159 13.9209 57.3758Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9893 66.9461C54.2795 66.2995 53.6561 65.6744 53.0112 65.9654C52.8715 66.0301 52.764 66.1378 52.6995 66.2779C52.3986 66.9245 53.0327 67.5496 53.6776 67.2586C53.8173 67.194 53.9248 67.0862 53.9893 66.9461Z",
    fill: "white",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.626 68.157C11.9162 67.5104 11.2928 66.8854 10.648 67.1764C10.5082 67.241 10.4007 67.3488 10.3363 67.4889C10.0353 68.1355 10.6694 68.7605 11.3143 68.4696C11.454 68.4049 11.5615 68.2971 11.626 68.157Z",
    fill: "white",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9129 25.0906C51.2039 24.444 50.5788 23.819 49.9322 24.11C49.7922 24.1746 49.6844 24.2824 49.6197 24.4225C49.3287 25.0691 49.9538 25.6941 50.6004 25.4032C50.7405 25.3385 50.8483 25.2307 50.9129 25.0906Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2352 13.5672C41.5262 12.9206 40.9011 12.2955 40.2545 12.5865C40.1144 12.6512 40.0066 12.7589 39.942 12.899C39.651 13.5456 40.2761 14.1707 40.9227 13.8797C41.0628 13.8151 41.1705 13.7073 41.2352 13.5672Z",
    fill: "white",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9366 35.7156C15.2268 35.069 14.6034 34.444 13.9585 34.735C13.8187 34.7996 13.7113 34.9074 13.6468 35.0475C13.3459 35.6941 13.98 36.3191 14.6249 36.0282C14.7646 35.9635 14.8721 35.8557 14.9366 35.7156Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6178 18.5672C42.3268 17.9206 42.9518 17.2955 43.5985 17.5865C43.7386 17.6512 43.8463 17.7589 43.911 17.899C44.2019 18.5456 43.5769 19.1707 42.9303 18.8797C42.7902 18.8151 42.6824 18.7073 42.6178 18.5672Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6254 73.5672C25.3352 72.9206 25.9586 72.2955 26.6034 72.5865C26.7432 72.6512 26.8507 72.7589 26.9151 72.899C27.2161 73.5456 26.582 74.1707 25.9371 73.8797C25.7973 73.8151 25.6899 73.7073 25.6254 73.5672Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4965 48.8211C13.2063 48.1745 13.8297 47.5494 14.4746 47.8404C14.6143 47.9051 14.7217 48.0129 14.7862 48.1529C15.0872 48.7996 14.4531 49.4246 13.8082 49.1336C13.6685 49.069 13.561 48.9612 13.4965 48.8211Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9008 33.5672C17.6106 32.9206 18.2339 32.2955 18.8788 32.5865C19.0186 32.6512 19.126 32.7589 19.1905 32.899C19.4915 33.5456 18.8573 34.1707 18.2124 33.8797C18.0727 33.8151 17.9653 33.7073 17.9008 33.5672Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1021 74.6609C48.8112 74.0143 49.4362 73.3893 50.0828 73.6803C50.2229 73.7449 50.3307 73.8527 50.3954 73.9928C50.6863 74.6394 50.0613 75.2644 49.4147 74.9735C49.2746 74.9088 49.1668 74.801 49.1021 74.6609Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0772 28.4891C64.3674 27.8425 63.744 27.2174 63.0991 27.5084C62.9594 27.5731 62.8519 27.6808 62.7874 27.8209C62.4865 28.4675 63.1206 29.0926 63.7655 28.8016C63.9052 28.7369 64.0127 28.6292 64.0772 28.4891Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7042 19.8953C76.0051 19.2487 75.371 18.6237 74.7261 18.9146C74.5864 18.9793 74.4789 19.0871 74.4144 19.2272C74.1242 19.8738 74.7476 20.4988 75.3925 20.2078C75.5322 20.1432 75.6397 20.0354 75.7042 19.8953Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2701 14.3484C65.9791 13.7018 66.6042 13.0768 67.2508 13.3678C67.3909 13.4324 67.4987 13.5402 67.5633 13.6803C67.8543 14.3269 67.2293 14.9519 66.5826 14.661C66.4425 14.5963 66.3348 14.4885 66.2701 14.3484Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2641 34.6777C69.9739 34.0328 70.5972 33.4094 71.2421 33.6996C71.3819 33.7641 71.4893 33.8716 71.5538 34.0113C71.8548 34.6562 71.2206 35.2903 70.5757 34.9894C70.436 34.9249 70.3285 34.8174 70.2641 34.6777Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32063 40.7156C4.01968 40.069 4.65381 39.444 5.2987 39.735C5.43842 39.7996 5.5459 39.9074 5.61039 40.0475C5.90059 40.6941 5.2772 41.3191 4.63231 41.0282C4.49259 40.9635 4.38512 40.8557 4.32063 40.7156Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2113 72.1219C61.9103 71.4753 62.5444 70.8502 63.1893 71.1412C63.3291 71.2059 63.4365 71.3136 63.501 71.4537C63.7912 72.1003 63.1678 72.7254 62.523 72.4344C62.3832 72.3698 62.2757 72.262 62.2113 72.1219Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5589 49.1336C28.258 48.487 28.8921 47.8619 29.537 48.1529C29.6767 48.2176 29.7842 48.3253 29.8487 48.4654C30.1389 49.112 29.5155 49.7371 28.8706 49.4461C28.7309 49.3815 28.6234 49.2737 28.5589 49.1336Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8792 48.5281C61.5783 47.8815 62.2124 47.2565 62.8573 47.5475C62.997 47.6121 63.1045 47.7199 63.169 47.86C63.4592 48.5066 62.8358 49.1316 62.1909 48.8407C62.0512 48.776 61.9437 48.6682 61.8792 48.5281Z",
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.481 65.911C42.1901 65.2643 42.8151 64.6393 43.4617 64.9303C43.6018 64.9949 43.7096 65.1027 43.7743 65.2428C44.0652 65.8894 43.4402 66.5144 42.7936 66.2235C42.6535 66.1588 42.5457 66.0511 42.481 65.911Z",
    fill: "white",
    fillOpacity: 0.32
  }))))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8766 18.839C41.7203 18.8527 42.1981 19.7704 41.7761 20.5012L26.359 47.2044C26.1522 47.5626 25.77 47.7833 25.3563 47.7833H18.9631C18.4348 47.7833 17.9704 47.4263 17.8588 46.9099C17.5163 45.3254 17.3359 43.6808 17.3359 41.9938C17.3359 29.2041 27.704 18.8359 40.4938 18.8359C40.6216 18.8359 40.7492 18.837 40.8766 18.839ZM47.1703 19.8129C46.6717 19.663 46.1415 19.8876 45.8812 20.3384L42.7615 25.7418C42.5547 26.1 42.5547 26.5414 42.7615 26.8996L58.3939 53.9757C58.8139 54.7031 59.8414 54.7523 60.2788 54.0351C62.4187 50.5266 63.6516 46.4041 63.6516 41.9938C63.6516 31.5252 56.7053 22.6789 47.1703 19.8129ZM56.2632 58.9531C56.6462 58.5967 56.7191 58.0221 56.4574 57.569L53.1474 51.8359C52.9406 51.4777 52.5583 51.257 52.1447 51.257H21.0324C20.1976 51.257 19.6411 52.1128 20.0329 52.8499C23.9241 60.1685 31.627 65.1517 40.4938 65.1517C46.586 65.1517 52.1287 62.7992 56.2632 58.9531ZM39.419 31.5312C39.8647 30.7592 40.9788 30.7592 41.4245 31.5312L49.805 46.0465C50.2506 46.8184 49.6935 47.7833 48.8021 47.7833H32.0414C31.15 47.7833 30.593 46.8184 31.0387 46.0465L39.419 31.5312Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 15.0293C55.3957 15.0293 67.4707 27.1043 67.4707 42C67.4707 56.8957 55.3957 68.9707 40.5 68.9707C25.6043 68.9707 13.5293 56.8958 13.5293 42C13.5293 27.1042 25.6043 15.0293 40.5 15.0293Z",
    stroke: "white",
    strokeWidth: 1.05769
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3379_90918",
    x: 3.46094,
    y: 0.688477,
    width: 72.7461,
    height: 82.6387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3379_90918"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3379_90918",
    x: 46.3035,
    y: 11.8025,
    width: 25.9028,
    height: 35.3296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26721,
    result: "effect1_foregroundBlur_3379_90918"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3379_90918",
    x: 5.46949,
    y: 33.1765,
    width: 25.9028,
    height: 35.3296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26721,
    result: "effect1_foregroundBlur_3379_90918"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3379_90918",
    x1: 39.834,
    y1: 0.0078125,
    x2: 39.834,
    y2: 84.0078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3379_90918",
    x1: 37.0528,
    y1: -0.775996,
    x2: 37.0528,
    y2: 104.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B22F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD774"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3379_90918",
    x1: 38.9883,
    y1: -0.5,
    x2: 38.9883,
    y2: 81.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3379_90918",
    x1: 27.2888,
    y1: 80.8743,
    x2: 27.2888,
    y2: 45.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3379_90918",
    x1: 37.2207,
    y1: -29.4258,
    x2: 37.2207,
    y2: 77.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3379_90918",
    x1: 85.6798,
    y1: -29.4258,
    x2: 85.6798,
    y2: 74.6869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3379_90918",
    x1: -4.46888,
    y1: -29.4258,
    x2: -4.46888,
    y2: 74.6869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3379_90918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5407 72.3829) rotate(-105.98) scale(64.8588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3379_90918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.729,
    height: 108.289,
    fill: "white",
    transform: "translate(-14.4727 -29.4258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCurrencyLogo);
export default __webpack_public_path__ + "static/media/CreditCurrencyLogo.a80016a4ef875caf44388cf0d454b3de.svg";
export { ForwardRef as ReactComponent };